import * as React from 'react';
import { LocationWithCoordinates } from 'lib/types';

export interface LocationsContextType {
    locations: ReadonlyArray<LocationWithCoordinates>;
}

const LocationsContext = React.createContext<LocationsContextType>({
    locations: [],
});

export default LocationsContext;
